import Icon from '@mdi/react'
import { Font16 } from 'components/Typography'
import styled from 'styled-components'
import theme from 'theme_'

export const SubsCancelFormContent = styled.div`
  ${Font16}
  line-height: 24px;
  margin: 0 auto;
  margin-top: 16px;
`
export const SubsCancelSuccessIconWrap = styled.div`
  margin-bottom: ${theme.spacing.md};
`
export const SubsCancelSuccessIcon = styled(Icon)`
  color: ${theme.colors.success};
`
